import {
  BaseTable,
  SortConfig,
  type Column,
} from '@/components/table/BaseTable'
import { Users } from '@/types/users'
import { css, Theme } from '@emotion/react'
import { Link } from 'react-router-dom'

const dateFormatter = new Intl.DateTimeFormat('ja-JP', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

const tableWrapperStyles = css`
  overflow-x: auto;
`

const LinkStyle = (t: Theme) => css`
  cursor: pointer;
  text-decoration: none;
  color: ${t.c.bc.primary};

  &:hover {
    text-decoration: underline;
  }
`

const loginIdWidth = 400
const nameWidth = 400
const roleWidth = 120
const createdAtWidth = 160
const updatedAtWidth = 160
const columns: Column<Users>[] = [
  {
    header: 'ID',
    accessor: (row) => {
      return (
        <Link css={LinkStyle} to={`${row.id}/view`}>
          {row.loginId}
        </Link>
      )
    },
    text: (row) => row.loginId,
    width: `${loginIdWidth}px`,
    isDetailLink: true,
    sortKey: 'login_id',
  },
  {
    header: 'アカウント名',
    text: (row) => row.name,
    width: `${nameWidth}px`,
  },
  {
    header: '権限',
    text: (row) => row.roleName,
    width: `${roleWidth}px`,
    sortKey: 'role',
    divStyle: {
      textAlign: 'center',
    },
  },
  {
    header: '登録日',
    text: (row) => {
      return dateFormatter.format(new Date(row.createdAt))
    },
    width: `${createdAtWidth}px`,
    divStyle: {
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  },
  {
    header: '更新日',
    text: (row) => {
      return row.updatedAt ? dateFormatter.format(new Date(row.updatedAt)) : ''
    },
    width: `${updatedAtWidth}px`,
    divStyle: {
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  },
]

type Props = {
  data: Users[]
  sortConfig?: SortConfig
  onSort?: (key: string) => void
}

export const UserTable = ({ data, sortConfig, onSort }: Props) => {
  return (
    <div css={tableWrapperStyles}>
      <BaseTable
        data={data}
        columns={columns}
        isDelete={false}
        viewName="view"
        sortConfig={sortConfig}
        onSort={onSort}
        width={`${loginIdWidth + nameWidth + roleWidth + createdAtWidth + updatedAtWidth}px`}
      />
    </div>
  )
}
